/**
 * SignupSuccess Page
 * Legacy redirect — signup no longer uses Stripe, but this route may still
 * receive traffic from old bookmarks or stale Stripe callbacks.
 * Redirects to the upgrade page (if session_id present) or to /create.
 */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { PageLayout } from '@/components';

export const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      // Forward Stripe session to the upgrade page which handles it
      navigate(`/upgrade?session_id=${sessionId}`, { replace: true });
    } else {
      navigate('/add', { replace: true });
    }
  }, [sessionId, navigate]);

  return (
    <PageLayout>
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
      </div>
    </PageLayout>
  );
};

export default SignupSuccess;
